import ManageSearchIcon from '@mui/icons-material/ManageSearch';

import { SearchSettingsEdit } from './SearchSettingsEdit';

export default {
    edit: SearchSettingsEdit,
    icon: ManageSearchIcon
};
